module.exports = __webpack_public_path__ + "img/delivery_map.525d689b.svg";